export const DESIGN_SETTINGS = ["primaryLogo", "primaryInverseLogo", "favicon"] as const;

export const DESIGN_INPUT_TYPES = ["bool", "color", "htmlText", "image", "text"] as const;

export const PAGE_STATUS_PUBLISHED = 1;
export const PAGE_STATUS_UNPUBLISHED = 0;
